<template>
  <div class="scanner-container">
    <div v-show="!isLoading">
      <video poster="data:image/gif,AAAA" ref="scanner" id="video"></video>
      <div class="overlay-element"></div><!-- {{ scanned_code }}-->
      <!-- <div class="laser"></div>  -->
    </div>
  </div>
</template>

<script>
//import { DecodeHintType,BrowserMultiFormatReader, Exception } from "@zxing/library";
import { BrowserDatamatrixCodeReader, Exception } from "@zxing/library";

export default {
  name: "stream-barcode-reader",
  props: {
    scanned_code: {
      type: String,
      default: "",
    },
  },
  data() {
    
    return {
      isLoading: true,
      //codeReader: new BrowserMultiFormatReader(),
      codeReader: new BrowserDatamatrixCodeReader(),
      isMediaStreamAPISupported: navigator && navigator.mediaDevices && "enumerateDevices" in navigator.mediaDevices,
    };
  },

  mounted() {
    if (!this.isMediaStreamAPISupported) {
      throw new Exception("Media Stream API is not supported");
      return;
    }

    this.start();
    this.$refs.scanner.oncanplay = (event) => {
      this.isLoading = false;
      this.$emit("loaded");
    };
  },

  beforeUnmount() {
    this.codeReader.reset();
  },
  beforeDestroy() {
    this.codeReader.reset();
  },

  methods: {
    start() {
      let video = document.getElementById('video');
    
      console.log(video.getBoundingClientRect())
      console.log('VIDEO_ELEMENT',typeof this.$refs.scanner);
      //alert('VIDEO_ELEMENT1',typeof this.$refs.scanner);
      this.codeReader.decodeFromVideoDevice(undefined, this.$refs.scanner, (result, err) => {
        if (result) {
          console.log(video.getBoundingClientRect())
          //alert(result);
          this.$emit("decode", result.text);
          this.$emit("result", result);
        }
      }).catch(error => this.$emit("error", error));
    },
  },
};
</script>

<style scoped>
video {
  max-width: 100%;
  max-height: 100%;
}
.scanner-container {
  position: relative;
}

.overlay-element {
  color: red;
  position: absolute;
  top: 0;
  width: 100%;
  height: 99%;
  /*background: rgba(30, 30, 30, 0.5);*/
  /* background-image: url('/img/barcode_bg.png'); */
  /* background-image: url('/img/barcode_bg_red.png'); */
  background-image: url('/img/barcode_bg_orange.png');
  background-repeat: no-repeat;
  background-position: center;
  
  animation: scanning_dm 2s infinite;
  /*
  -webkit-clip-path: polygon(0% 0%, 0% 100%, 20% 100%, 20% 20%, 80% 20%, 80% 80%, 20% 80%, 20% 100%, 100% 100%, 100% 0%);
  clip-path: polygon(0% 0%, 0% 100%, 20% 100%, 20% 20%, 80% 20%, 80% 80%, 20% 80%, 20% 100%, 100% 100%, 100% 0%);*/
}

.laser {
  width: 60%;
  margin-left: 20%;
  background-color: tomato;
  height: 1px;
  position: absolute;
  top: 80%;
  z-index: 2;
  box-shadow: 0 0 4px red;
  -webkit-animation: scanning 2s infinite;
  animation: scanning 2s infinite;
}

@-webkit-keyframes scanning_dm {
  50% {
    opacity: 0.2;
  }
}
@keyframes scanning_dm {
  50% {
    opacity: 0.2;
  }

  
}

@-webkit-keyframes scanning {
  50% {
    top:20%;
  }
}
@keyframes scanning {
  50% {
    top:20%;
  }

  
}
</style>
